/**
 * Bit-flag values for a FilterCheckComboBox whose FilterSettings carries
 * `Flags={...}`. The checkboxes hold one flag each, but the server parameter
 * is a single Int (e.g. GroupSalesReportLevel), so the picks are OR'd before
 * they leave the client — a CSV like "64,32" fails SqlParameter's Int32
 * coercion. Mirrors WebAdmin2 comboboxfilter.ts getValue / getFlagsValue.
 */

/** "64,32" → 96. Blank and non-numeric tokens are skipped. */
export function encodeFlags(csv: string): number {
  let out = 0;
  for (const tok of csv.split(",")) {
    const n = parseInt(tok.trim(), 10);
    if (!Number.isNaN(n)) out |= n;
  }
  return out;
}

/** 96 → "64,32" (in Flags order). Accepts an already-CSV value unchanged, so a
 *  filter saved before encoding was fixed still restores its checkboxes. */
export function decodeFlags(value: unknown, flags: Record<string, number>): string {
  const str = value == null ? "" : String(value).trim();
  if (str === "" || str.includes(",")) return str;
  const n = parseInt(str, 10);
  if (Number.isNaN(n)) return str;
  return Object.entries(flags)
    .filter(([label, flag]) => label !== "default" && flag !== 0 && (n & flag) === flag)
    .map(([, flag]) => String(flag))
    .join(",");
}
